import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function takeScreenshot(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish, setImage } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const pixelRatio = args.pixelRatio ?? 2;
	if (typeof pixelRatio !== 'number' || pixelRatio <= 0) {
		return { success: false, error: 'pixelRatio parameter must be a positive number' };
	}

	return new Promise<ToolResult>((resolve) => {
		threeInstance.getImageRender(pixelRatio, (imageData: string) => {
			setImage(imageData);
			
			publish('screenshot', 'taken', {
				ref: 'screenshot',
				old: null,
				new: { pixelRatio }
			});
			
			resolve({ success: true, data: { imageData, pixelRatio }});
		});
	});
}
